export default "__VITE_ASSET__Pq5OSo3L__"